import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from '../Beats.module.css'; 
import { getImageUrl } from '../services/r2Service';

const Beats: React.FC = () => {
  const [imagesLoaded, setImagesLoaded] = useState(0);

  const handleImageLoad = () => {
    setImagesLoaded(prev => prev + 1);
  };

  return (
    <div>
      <h1>Beat Tapes</h1>
      <div className={styles.container}>
        <div className={styles.item}>
          <Link to="/vol1">
            <div className={`${styles.imageWrapper} ${imagesLoaded === 4 ? styles.loaded : ''}`}>
              <img 
                src={getImageUrl('vol1.jpg')} 
                alt="Vol 1" 
                className={styles.image}
                loading="eager"
                decoding="async"
                onLoad={handleImageLoad}
              />
            </div>
            <p className={styles.caption}>Vol 1</p>
          </Link>
        </div>
        <div className={styles.item}>
          <Link to="/vol2">
            <div className={`${styles.imageWrapper} ${imagesLoaded === 4 ? styles.loaded : ''}`}>
              <img 
                src={getImageUrl('vol2.jpeg')} 
                alt="Vol 2" 
                className={styles.image}
                loading="eager"
                decoding="async"
                onLoad={handleImageLoad}
              />
            </div>
            <p className={styles.caption}>Vol 2</p>
          </Link>
        </div>
        <div className={styles.item}>
          <Link to="/vol3">
            <div className={`${styles.imageWrapper} ${imagesLoaded === 4 ? styles.loaded : ''}`}>
              <img 
                src={getImageUrl('vol3.jpg')} 
                alt="Vol 3" 
                className={styles.image}
                loading="eager"
                decoding="async"
                onLoad={handleImageLoad}
              />
            </div>
            <p className={styles.caption}>Vol 3</p>
          </Link>
        </div>
        <div className={styles.item}>
          <Link to="/vol4">
            <div className={`${styles.imageWrapper} ${imagesLoaded === 4 ? styles.loaded : ''}`}>
              <img 
                src={getImageUrl('vol4.png')} 
                alt="Vol 4" 
                className={styles.image}
                loading="eager"
                decoding="async"
                onLoad={handleImageLoad}
              />
            </div>
            <p className={styles.caption}>Vol 4</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Beats;
